// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

type HtmlAttributes = {
  [key: string]: string | number
}
type LucideIconNode = readonly [string, HtmlAttributes]
type LucideIconData = readonly LucideIconNode[]

export const StepperIndicatorAlert: LucideIconData = [
  [
    "line",
    {key: "1pkeuh", "stroke-width": "3", x1: "12", x2: "12", y1: "6", y2: "13"},
  ],
  [
    "line",
    {
      key: "4dfq90",
      "stroke-width": "3",
      x1: "12",
      x2: "12.01",
      y1: "18",
      y2: "18",
    },
  ],
]
